import React from "react";
import { X } from "lucide-react";

export default function POMarkupModal({
  isOpen,
  onClose,
  onSubmit,
  markupPo,
  tempMarkupRate,
  setTempMarkupRate,
  error
}) {
  if (!isOpen || !markupPo) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "400px" }}>
        <div className="modal-header">
          <h3>EST Custom Markup</h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <form onSubmit={onSubmit}>
          {error && (
            <div className="login-error-alert animate-fade-in" style={{ marginBottom: "1rem" }}>
              {error}
            </div>
          )}
          <div className="form-group">
            <p className="text-secondary" style={{ fontSize: "0.85rem", marginBottom: "1.25rem", lineHeight: "1.4" }}>
              Adjust the markup percentage for <strong>{markupPo.poNumber}</strong>. This custom rate applies only to this EST and automatically recalculates all line items.
            </p>
            <label className="form-label" htmlFor="customMarkup">Markup Rate (%)</label>
            <input
              id="customMarkup"
              type="number"
              min="0"
              max="100"
              step="0.1"
              required
              className="form-input"
              value={tempMarkupRate}
              onChange={(e) => setTempMarkupRate(e.target.value)}
              onFocus={(e) => e.target.select()}
              onClick={(e) => e.target.select()}
            />
            <span className="text-secondary" style={{ fontSize: "0.8rem", display: "block", marginTop: "0.5rem" }}>
              Global default markup is currently {localStorage.getItem("global_markup_rate") || 15}%.
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", marginTop: "1.5rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Apply & Recalculate
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
